import { motion } from "framer-motion"
import { useInView } from "react-intersection-observer"

const MobileEngineering = () => {
    const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 })

    return (
        <div className="w-full mx-auto p-6 lg:px-12 lg:py-16 text-zinc-800 dark:text-zinc-200 text-sm" ref={ref}>
            <div className="grid lg:grid-cols-2 gap-12 items-center justify-between">

                <motion.div 
                    className="lg:w-10/12 space-y-6 lg:order-2"
                    initial={{ opacity: 0, x: 50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="flex flex-row text-zinc-800 dark:text-zinc-200 font-light items-center justify-between">
                        <div className="flex justify-start space-x-3 items-center">
                            <span className="text-purple-600 dark:text-purple-400 font-mono text-xl font-bold">01</span>
                            <span className="text-3xl lg:text-4xl font-bold text-zinc-900 dark:text-white">Process Automation Audits</span>
                        </div>
                    </div>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Operational efficiency begins with auditing legacy systems. We review your team's repetitive tasks, document generation procedures, and messaging funnels to design a clear, actionable roadmap for plugging in off-the-shelf AI agents.
                    </p>
                    <p className="text-zinc-600 dark:text-zinc-400 font-roboto font-light leading-relaxed">
                        Our audits reveal immediate automation opportunities that reduce human error, eliminate manual bottlenecks, and free up team capacity to focus on strategic company growth.
                    </p>
                </motion.div>

                <motion.div 
                    className="mx-auto lg:w-9/12 w-full lg:order-1"
                    initial={{ opacity: 0, x: -50 }}
                    animate={inView ? { opacity: 1, x: 0 } : {}}
                    transition={{ duration: 0.6 }}
                >
                    <div className="p-6 rounded-2xl border border-slate-200 dark:border-purple-500/20 bg-white dark:bg-[#202222] shadow-[0_4px_20px_rgba(0,0,0,0.03)] dark:shadow-[0_0_35px_rgba(168,85,247,0.08)] hover-glow transition-all duration-300">
                        <div className="flex justify-between items-center mb-6 border-b border-slate-200 dark:border-slate-800/80 pb-3">
                            <span className="font-semibold text-zinc-900 dark:text-white">Process Audit Report</span>
                            <span className="text-[10px] text-purple-700 dark:text-purple-400 font-mono px-2 py-0.5 rounded bg-purple-100 dark:bg-purple-500/10 font-medium">STABLE</span>
                        </div>
                        <div className="space-y-4 font-mono text-[11px]">
                            <div className="flex justify-between items-center text-zinc-700 dark:text-zinc-300">
                                <span>Email Support Sorting</span>
                                <span className="text-green-600 dark:text-green-400 font-bold">85% Automated</span>
                            </div>
                            <div className="w-full bg-slate-100 dark:bg-slate-900 rounded-full h-1.5 overflow-hidden">
                                <div className="bg-purple-600 dark:bg-purple-500 h-full w-[85%] rounded-full"></div>
                            </div>

                            <div className="flex justify-between items-center text-zinc-700 dark:text-zinc-300 pt-2">
                                <span>Lead Data Entry & CRM</span>
                                <span className="text-green-600 dark:text-green-400 font-bold">90% Automated</span>
                            </div>
                            <div className="w-full bg-slate-100 dark:bg-slate-900 rounded-full h-1.5 overflow-hidden">
                                <div className="bg-purple-600 dark:bg-purple-500 h-full w-[90%] rounded-full"></div>
                            </div>

                            <div className="flex justify-between items-center text-zinc-700 dark:text-zinc-300 pt-2">
                                <span>Document Synthesis</span>
                                <span className="text-green-600 dark:text-green-400 font-bold">75% Automated</span>
                            </div>
                            <div className="w-full bg-slate-100 dark:bg-slate-900 rounded-full h-1.5 overflow-hidden">
                                <div className="bg-purple-600 dark:bg-purple-500 h-full w-[75%] rounded-full"></div>
                            </div>
                        </div>
                    </div>
                </motion.div>

            </div>
        </div>
    )
}

export default MobileEngineering